import React, { Component } from 'react';

import About from '../About/About';
import Contact from '../../../ContactPage/ContactPage';
import EmailListModal from '../../../Modal/EmailListModal/EmailListModal';

import classes from './HowItWorksPage.css';


class HowItWorksPage extends Component {
    
    state = {
        aboutPage: true,
        trdInfo: false,
        accountCreation: false,
        sellerInfo: false,
        faq: false,              //  maybe setup a contact us page to report or ask concerns and develop a faq
        contact: false,
        showEmailModal: false
    }


    componentDidMount = () => {
       this.setNav()
       this.scrollToTop()
    }

    componentDidUpdate = () => {
        this.scrollToTop()
    }

    scrollToTop = () => {
        window.scrollTo(0,0)
    }


    setAboutState = () => {

        this.setState({ 
            aboutPage: true,
            trdInfo: false,
            accountCreation: false,
            seelerInfo: false,
            faq: false,
            contact: false
        })

    }

    setTrdState = () => {
        this.setState({ aboutPage: false,
                        trdInfo: true,
                        accountCreation: false,
                        seelerInfo: false,
                        faq: false,
                        contact: false
                    })
    }

    setContactState = () => {
        this.setState({ aboutPage: false,
                        trdInfo: false,
                        accountCreation: false,
                        seelerInfo: false,
                        faq: false,
                        contact: true
                    })
    }


    setNav = () => {
        switch (this.props.match.params.val) {
            case 'about':  // about tab highlighted and selected
                this.setState({
                    aboutPage: true,
                    trdInfo: false,
                    accountCreation: false,
                    seelerInfo: false,
                    faq: false,
                    contact: false
                })
                break;
            case 'contact':  // contact tab highlighted and selected
                this.setState({
                    aboutPage: false,
                    trdInfo: false,
                    accountCreation: false,
                    seelerInfo: false,
                    faq: false,
                    contact: true
                })
                break;
            default:     
        }
    }

    showEmailModalHandler = () => {
        this.setState({showEmailModal: true})
    }

    closeEmailModalHelper = () => {
        this.setState({showEmailModal: false})
    }



    render() {


        // this.setNav()


        let infoSection = null

        let aboutCSS = [classes.About]
        let contactCSS = [classes.Contact]

        if (this.state.aboutPage) {
            infoSection = <About clicked={this.showEmailModalHandler}/>
            aboutCSS = [classes.About, classes.Highlight]
        }else if (this.state.trdInfo) {

        }else if (this.state.accountCreation) {

        }else if (this.state.sellerInfo) {

        }else if (this.state.faq) {

        }else if(this.state.contact) {
            infoSection = <Contact />
            contactCSS = [classes.Contact, classes.Highlight]
        }



        return (
            <div className={classes.HowItWorksPage}>
                <div className={classes.TopNavigation}>
                    <h3 className={aboutCSS.join(' ')} onClick={this.setAboutState}>About</h3>
                    <p>|</p>
                    <h3 className={contactCSS.join(' ')} onClick={this.setContactState}>Contact</h3>
                </div>
                <div className={classes.InfoSection}>
                    {infoSection}
                </div>
                <EmailListModal show={this.state.showEmailModal} modalClosed={this.closeEmailModalHelper}/>
            </div>
        )
    }
}

export default HowItWorksPage;


// WEBPACK FOOTER //
// ./src/components/UI/HowItWorks/TrdHowItWorks/HowItWorksPage/HowItWorksPage.js